export const CANDIDATE_JOINED = "CANDIDATE_JOINED";
export const ALLOW_USER = "ALLOW_USER";
export const END_INTERVIEW_FOR_ALL = "END_INTERVIEW_FOR_ALL";
export const LEAVE_INTERVIEW = "LEAVE_INTERVIEW";
export const GRACEFUL_SHUTDOWN = "GRACEFUL_SHUTDOWN";
export const GET_USER_STATUS = "GET_USER_STATUS";
export const JOIN_INTERVIEW = "JOIN_INTERVIEW";
export const START_INTERVIEW = "START_INTERVIEW";

export const CODE_EDITOR_LIBRARY_LOADED = "CODE_EDITOR_LIBRARY_LOADED";
export const GET_TECHNOLOGIES = "GET_TECHNOLOGIES";

export const GET_ZOOM_CHAT_HISTORY = "GET_ZOOM_CHAT_HISTORY";
export const CREATE_ZOOM_CLIENT = "CREATE_ZOOM_CLIENT";
export const REMOVE_ZOOM_CLIENT = "REMOVE_ZOOM_CLIENT";
export const SAVE_ZOOM_STREAM = "SAVE_ZOOM_STREAM";
export const UPDATE_ZOOM_VIDEO_STARTED = "UPDATE_ZOOM_VIDEO_STARTED";
export const UPDATE_ZOOM_AUDIO_STARTED = "UPDATE_ZOOM_AUDIO_STARTED";
export const UPDATE_ZOOM_CONNECTION_STATUS = "UPDATE_ZOOM_CONNECTION_STATUS";

export const UPDATE_PERMISSIONS = "UPDATE_PERMISSIONS";

export const GET_ALL_QUESTIONS = "GET_ALL_QUESTIONS";
export const ADD_QUESTION = "ADD_QUESTION";
export const REMOVE_QUESTION = "REMOVE_QUESTION";
export const UPDATE_QUESTION = "UPDATE_QUESTION";
export const SET_CANDIDATE_ACTIVE_TAB = "SET_CANDIDATE_ACTIVE_TAB";

export const CREATE_OR_UPDATE_CODING_SOLUTION =
  "CREATE_OR_UPDATE_CODING_SOLUTION";
export const GET_WHITEBOARD_SOLUTION = "GET_WHITEBOARD_SOLUTION";
export const GET_CODING_SOLUTION = "GET_CODING_SOLUTION";
export const CREATE_OR_UPDATE_WHITEBOARD_SOLUTION =
  "CREATE_OR_UPDATE_WHITEBOARD_SOLUTION";
export const SAVE_ELEMENTS_AND_FILES = "SAVE_ELEMENTS_AND_FILES";
export const SET_IS_GET_SOLUTION = "SET_IS_GET_SOLUTION";
export const SET_IS_GET_WHITEBOARD_SOLUTION = "SET_IS_GET_WHITEBOARD_SOLUTION";
export const REMOVE_SOLUTION = "REMOVE_SOLUTION";
export const UPDATE_TECHNOLOGY = "UPDATE_TECHNOLOGY";
export const UPDATE_CODE = "UPDATE_CODE";

export const RUN_CODE = "RUN_CODE";
export const CUSTOM_INPUT_RUN_CODE = "CUSTOM_INPUT_RUN_CODE";
export const TEST_CASE_RUN_CODE = "TEST_CASE_RUN_CODE";
export const SET_RUN_CODE_IN_PROCESS = "SET_RUN_CODE_IN_PROCESS";
export const ABORT_RUN_CODE = "ABORT_RUN_CODE";
export const SET_ABORT_RUN_CODE_IN_PROCESS = "SET_ABORT_RUN_CODE_IN_PROCESS";
export const COLLAB_RUN_CODE = "COLLAB_RUN_CODE";
export const UPDATE_TEST_CASE_RESULT_IN_SOLUTION =
  "UPDATE_TEST_CASE_RESULT_IN_SOLUTION";

export const GET_LIBRARY_PROBLEMS = "GET_LIBRARY_PROBLEMS";

export const UPDATE_INTERVIEWER_DETAILS = "UPDATE_INTERVIEWER_DETAILS";
export const CREATE_INTERVIEW_RATING = "CREATE_INTERVIEW_RATING";
export const UPDATE_INTERVIEW_RATING = "UPDATE_INTERVIEW_RATING";
export const GET_SCORECARD = "GET_SCORECARD";
export const SUBMIT_QUESTION_SCORE = "SUBMIT_QUESTION_SCORE";
export const UPDATE_QUESTION_SCORE = "UPDATE_QUESTION_SCORE";
export const SET_OTP_ERROR = "SET_OTP_ERROR";
export const SET_OTP_LOADING = "SET_OTP_LOADING";
export const GET_SERVER_TIME = "GET_SERVER_TIME";

export const GET_INTERVIEW_META = "GET_INTERVIEW_META";
export const GET_INTERVIEW_DETAILS = "GET_INTERVIEW_DETAILS";
export const SET_STARTED_TIME = "SET_STARTED_TIME";

export const GET_ALL_PARTICIPANTS = "GET_ALL_PARTICIPANTS";
export const PARTICIPANT_LEFT = "PARTICIPANT_LEFT";
export const ADD_PARTICIPANT = "ADD_PARTICIPANT";

export const SET_SOCKET = "SET_SOCKET";

export const UPDATE_PROGRESS = "UPDATE_PROGRESS";
export const SHOW_TOAST = "SHOW_TOAST";
export const HIDE_TOAST = "HIDE_TOAST";

export const SHOW_ERROR_PAGE = "SHOW_ERROR_PAGE";
export const HIDE_ERROR_PAGE = "HIDE_ERROR_PAGE";
export const MULTIPLE_TAB_DETECTED = "MULTIPLE_TAB_DETECTED";

export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";

export const SHOW_CREATE_QUESTION_MODAL = "SHOW_CREATE_QUESTION_MODAL";
export const HIDE_CREATE_QUESTION_MODAL = "HIDE_CREATE_QUESTION_MODAL";

export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";
//
export const UPDATE_API_CALL_STATUS = "UPDATE_API_CALL_STATUS";

export const MOVE_CANDIDATE_TO_LOBBY = "MOVE_CANDIDATE_TO_LOBBY";

export const SET_USER_JOIN_LEAVE_NOTIFICATION =
  "SET_USER_JOIN_LEAVE_NOTIFICATION";

export const SET_SINGLE_CODE_CHUNK_FOR_USER_FOR_QUESTION =
  "SET_SINGLE_CODE_CHUNK_FOR_USER_FOR_QUESTION";

export const DELETE_SINGLE_CODE_CHUNK_FOR_USER_FOR_QUESTION =
  "DELETE_SINGLE_CODE_CHUNK_FOR_USER_FOR_QUESTION";

export const MERGE_AND_UPDATE_CODE = "MERGE_AND_UPDATE_CODE";
export const SET_SINGLE_WHITEBOARD_COLLOBARATOR =
  "SET_SINGLE_WHITEBOARD_COLLOBARATOR";
export const DELETE_SINGLE_WHITEBOARD_COLLOBARATOR =
  "DELETE_SINGLE_WHITEBOARD_COLLOBARATOR";
export const DELETE_SINGLE_DRAWING_CHUNK_FOR_USER_FOR_QUESTION =
  "DELETE_SINGLE_DRAWING_CHUNK_FOR_USER_FOR_QUESTION";
export const MERGE_AND_UPDATE_DRAWING = "MERGE_AND_UPDATE_DRAWING";
export const SET_SINGLE_DRAWING_CHUNK_FOR_USER_FOR_QUESTION =
  "SET_SINGLE_DRAWING_CHUNK_FOR_USER_FOR_QUESTION";

export const SET_WHITE_LABEL_ENABLED = "SET_WHITE_LABEL_ENABLED";

export const GET_PLATFORM_META = "GET_PLATFORM_META";

export const GET_INTERVIEW_CONFIG = "GET_INTERVIEW_CONFIG";

export const GET_SUBJECTIVE_SOLUTION = "GET_SUBJECTIVE_SOLUTION";
export const CREATE_OR_UPDATE_SUBJECTIVE_SOLUTION =
  "CREATE_OR_UPDATE_SUBJECTIVE_SOLUTION";
export const SET_SUBJECTIVE_SOLUTION = "SET_SUBJECTIVE_SOLUTION";
export const SET_SUBJECTIVE_SOLUTION_MODIFIED_AT =
  "SET_SUBJECTIVE_SOLUTION_MODIFIED_AT";
export const SET_SUBJECTIVE_ATTACHMENTS = "SET_SUBJECTIVE_ATTACHMENTS";
export const GET_SUBJECTIVE_ATTACHMENTS = "GET_SUBJECTIVE_ATTACHMENTS";
export const UPLOAD_SUBJECTIVE_ATTACHMENTS = "UPLOAD_SUBJECTIVE_ATTACHMENTS";
export const DELETE_SUBJECTIVE_ATTACHMENT = "DELETE_SUBJECTIVE_ATTACHMENT";

export const SET_SINGLE_SUBJECTIVE_CHUNK_FOR_USER_FOR_QUESTION =
  "SET_SINGLE_SUBJECTIVE_CHUNK_FOR_USER_FOR_QUESTION";
export const DELETE_SINGLE_SUBJECTIVE_CHUNK_FOR_USER_FOR_QUESTION =
  "DELETE_SINGLE_SUBJECTIVE_CHUNK_FOR_USER_FOR_QUESTION";
export const MERGE_AND_UPDATE_SUBJECTIVE_CONTENT =
  "MERGE_AND_UPDATE_SUBJECTIVE_CONTENT";
export const SET_SUBJECTIVE_CURSOR = "SET_SUBJECTIVE_CURSOR";
export const CLEAR_SUBJECTIVE_CURSORS = "CLEAR_SUBJECTIVE_CURSORS";
